import React from 'react';
import './UKUniversities.css';

const universities = {
  I: [
    "INSEAD Asia Campus (Singapore)",
  ],
  J: [
    "James Cook University Singapore",
  ],
  L: [
    "LASALLE College of the Arts",
    "Lee Kong Chian School of Medicine",
  ],
  N: [
    "Nanyang Academy of Fine Arts (NAFA)",
    "Nanyang Technological University (NTU)",
    "National University of Singapore (NUS)",
  ],
  R: [
    "Republic Polytechnic",
  ],
  S: [
    "Singapore Institute of Management (SIM)",
    "Singapore Institute of Technology (SIT)",
    "Singapore Management University (SMU)",
    "Singapore Polytechnic",
    "Singapore University of Social Sciences (SUSS)",
    "Singapore University of Technology and Design (SUTD)",
  ],
  T: [
    "Temasek Polytechnic",
  ]
};

const SingaporeUniversities = () => {
  return (
    <div className="uk-container">
      <h2 className="uk-title">Singapore Universities</h2>
      <table className="uk-table">
        <thead>
          <tr>
            <th>Letter</th>
            <th>University Name</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(universities).map(([letter, uniList]) =>
            uniList.map((uni, idx) => (
              <tr key={`${letter}-${idx}`}>
                <td>{idx === 0 ? letter : ''}</td>
                <td>{uni}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SingaporeUniversities;
